import { ColumnStore } from "@bryntum/schedulerpro";
import { TAGS_KEYS } from "../../../other/constants/TagsKeys.jsx";
import { WIDGET_KEYS } from "../../../other/constants/WidgetKeys.jsx";
import { SETTING_TAB_WIDGET_KEYS} from "../../../other/constants/OtherKeys.jsx";
import SwivuSortColumn from "../SwivuSortColumn.jsx";
import {
  getCustomGroupRenderer,
} from "../../../other/utils/utils.jsx";
import { STORE_KEYS } from "../../../other/constants/StoreKeys.jsx";
import { EDITOR_KEYS } from "../../../other/constants/EditorKeys.jsx";
import { tagWidget, tagWidgetForEach } from "../../../other/utils/otherUtils.jsx";


class ContactTagsColumn extends SwivuSortColumn {

  static get fields() {
    return ["swivuListTitle"]
  }

  static get $name() {
    return "ContactTagsColumn";
  }

  static get type() {
    return WIDGET_KEYS.columnContactTag;
  }

  static get defaults() {
    return {
      text: "Tags",
      field: "_tags",
      maxWidth: "40em",
      cellCls: "swivu-recipients-cell gap-[0.3em]",
      flex: 1,
      groupRenderer(e) {
        return getCustomGroupRenderer(e, 'tagValue');
      },
      editor: false
    }
  }

  renderer({ record }) {

    if (!record.isGroupHeader && this.project) {
      const recordTags = record._tags || record.contactRecord?._tags;
      return tagWidgetForEach(recordTags);
    }
  }

  onLoad(project, { editorHandler }) {
    this.project = project;
    this.editorHandler = editorHandler;
  }

  get canMultiSelectSwivuList() {
    return true
  }

  get swivuListItems() {
    return this.project.getCrudStore(STORE_KEYS.contactTagValuesStore).query((record) => {
      return record.tagSet === TAGS_KEYS.tag
    }, true)
  }

  getSwivuListItemDisplayValue(record) {
    return record.tagValue;
  }

  getSelectedSwivuListItem(record) {
    return record._tags;
  }

  onSwivuListSelectionChange(record, contactRecords) {
    record._tags = contactRecords.map(item => item.id);
  }

  onSwivuManageList() {
    this.editorHandler.openEditor(EDITOR_KEYS.settingGeneralEditor, null, {
      selectTabByTypeOnOpen: SETTING_TAB_WIDGET_KEYS.contactTagsTab
    }, { by: "recordType", useExisting: true })
  }
}

class ContactStatusColumn extends SwivuSortColumn {
  static get fields() {
    return ["swivuListTitle"]
  }

  static get $name() {
    return "ContactStatusColumn";
  }

  static get type() {
    return WIDGET_KEYS.columnContactStatus;
  }

  static get defaults() {
    return {
      text: "Status",
      field: "statusValue",
      maxWidth: "40em",
      cellCls: "swivu-recipients-cell gap-[0.3em]",
      flex: 1,
      groupRenderer(e) {
        return getCustomGroupRenderer(e, 'tagValue');
      },
      editor: false
    }
  }

  renderer({ record }) {
    if (!record.isGroupHeader && this.project) {
      return tagWidget(record.contactRecord?._status?.tagValue || record.statusValue);
    }
  }

  onLoad(project, { editorHandler }) {
    this.project = project;
    this.editorHandler = editorHandler;
  }

  get canMultiSelectSwivuList() {
    return false
  }

  get swivuListItems() {
    return this.project.getCrudStore(STORE_KEYS.contactTagValuesStore).query((record) => {
      return record.tagSet === TAGS_KEYS.status
    }, true)
  }

  getSwivuListItemDisplayValue(record) {
    return record.tagValue;
  }

  getSelectedSwivuListItem(record) {
    return record._status;
  }

  onSwivuListSelectionChange(record, contactRecords) {
    record._status = contactRecords.map(item => item.id)[0];
  }

  onSwivuManageList() {
    this.editorHandler.openEditor(EDITOR_KEYS.settingGeneralEditor, null, {
      selectTabByTypeOnOpen: SETTING_TAB_WIDGET_KEYS.contactStatusTab
    }, { by: "recordType", useExisting: true })
  }
}

class ContactCategoryColumn extends SwivuSortColumn {

  static get fields() {
    return ["swivuListTitle"]
  }

  static get $name() {
    return "ContactCategoryColumn";
  }

  static get type() {
    return WIDGET_KEYS.columnContactCategory;
  }

  static get defaults() {
    return {
      text: "Category",
      field: "categoryValue",
      maxWidth: "40em",
      cellCls: "swivu-recipients-cell gap-[0.3em]",
      flex: 1,
      groupRenderer(e) {
        return getCustomGroupRenderer(e, 'tagValue');
      },
      editor: false
    }
  }

  renderer({ record }) {
    if (!record.isGroupHeader && this.project) {
      return tagWidget(record.contactRecord?._category?.tagValue || record.categoryValue);
    }
  }

  onLoad(project, { editorHandler }) {
    this.project = project;
    this.editorHandler = editorHandler;
  }

  get canMultiSelectSwivuList() {
    return false
  }

  get swivuListItems() {
    return this.project.getCrudStore(STORE_KEYS.contactTagValuesStore).query((record) => {
      return record.tagSet === TAGS_KEYS.category
    }, true)
  }

  getSwivuListItemDisplayValue(record) {
    return record.tagValue;
  }

  getSelectedSwivuListItem(record) {
    return record._category;
  }

  onSwivuListSelectionChange(record, contactRecords) {
    record._category = contactRecords.map(item => item.id)[0];
  }

  onSwivuManageList() {
    this.editorHandler.openEditor(EDITOR_KEYS.settingGeneralEditor, null, {
      selectTabByTypeOnOpen: SETTING_TAB_WIDGET_KEYS.contactCategoryTab
    }, { by: "recordType", useExisting: true })
  }
}


ColumnStore.registerColumnType(ContactCategoryColumn);
ColumnStore.registerColumnType(ContactStatusColumn);
ColumnStore.registerColumnType(ContactTagsColumn);
